/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-irregular-whitespace */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  checkValidMobileNumber,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  PREF_CLASS_OPTIONS,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  formatDate,
  formatTimeString,
  getCabinBaggage,
  getConnectingTime,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import FlightEmailCard from '../one-way/FlightEmailCard';
import { getUserDetails } from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { useAppContext } from '../../saas/AppConfigWrapper';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';

function RoundTripWhatsappModal({
  searchRequest,
  onSend,
  selectedOnwardFlights,
  selectedReturnFlights,
}) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [selectedOnwardFares, setSelectedOnwardFares] = useState(
    selectedOnwardFlights.map((d) => {
      return d.fare.totalfq;
    }),
  );
  const [selectedReturnFares, setSelectedReturnFares] = useState(
    selectedReturnFlights.map((d) => {
      return d.fare.totalfq;
    }),
  );
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [countryCode, setCountryCode] = useState('91');
  const [userDetails, setUserDetails] = useState(null);

  const getUserData = async () => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      setUserDetails(User);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };

  const handelSend = () => {
    if (
      whatsappNumber === '' ||
      whatsappNumber === undefined ||
      checkValidMobileNumber(whatsappNumber)
    ) {
      setValidationError(true);
      return false;
    }
    const numberWithCountryCode = countryCode + whatsappNumber;
    setIsLoading(true);
    let fromEmail = '';
    let contactNum = '';
    let companyName = '';
    if (!isEmpty(userDetails)) {
      fromEmail = userDetails.ContactEmail;
      contactNum = userDetails.ContactNumber;
      companyName = userDetails.Company;
    }
    let msg = '';
    msg += 'Onward Flight Options --->\n';
    selectedOnwardFlights.forEach((flt, onwardIndex) => {
      flt.flight.flightlegs.forEach((leg, index) => {
        msg += `${index === 0 ? onwardIndex + 1 : ''} ${
          index === 0 ? '-' : ''
        } ${leg.validatingcarriername} ${leg.carrier.substring(0, 2)} - ${
          leg.flightnumber
        } | ${leg.origin_name} - ${formatDate(
          getNewDate(leg.depdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.deptime)} --> ${
          leg.destination_name
        } - ${formatDate(
          getNewDate(leg.arrdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.arrtime)} \n`;
        msg += `Cabin Baggage: 7Kg \nCheckin Baggage: ${getCabinBaggage(
          flt.fare.flightBagWeight[index],
          flt.fare.flightBagUnit[index],
        )} \n`;
        if (
          leg.destination !==
          flt.flight.flightlegs[flt.flight.flightlegs.length - 1].destination
        ) {
          msg += `-------- ${getConnectingTime(
            leg.arrtime,
            leg.arrdate,
            flt.flight.flightlegs[index + 1].deptime,
            flt.flight.flightlegs[index + 1].depdate,
          )} layover in ${leg.destination_name} -------\n`;
        }
      });
      msg += `\nCabin Type : ${PREF_CLASS_OPTIONS[searchRequest.prefclass]}\n`;
      msg += `Stops : ${
        flt.flight.numstops !== 0 ? flt.flight.numstops : 'Non'
      } Stop\n`;
      if (showBreakup) {
        msg += `${flt.fare.faretype} Fare : ${
          appConfig?.appCurrency
        } ${getAmount(selectedOnwardFares[onwardIndex])}\n`;
      }
    });
    msg += 'Return Flight Options --->\n';
    selectedReturnFlights.forEach((flt, returnIndex) => {
      flt.flight.flightlegs.forEach((leg, index) => {
        msg += `${index === 0 ? returnIndex + 1 : ''} ${
          index === 0 ? '-' : ''
        } ${leg.validatingcarriername} ${leg.carrier.substring(0, 2)} - ${
          leg.flightnumber
        } | ${leg.origin_name} - ${formatDate(
          getNewDate(leg.depdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.deptime)} --> ${
          leg.destination_name
        } - ${formatDate(
          getNewDate(leg.arrdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.arrtime)} \n`;
        msg += `Cabin Baggage: 7Kg \nCheckin Baggage: ${getCabinBaggage(
          flt.fare.flightBagWeight[index],
          flt.fare.flightBagUnit[index],
        )} \n`;
        if (
          leg.destination !==
          flt.flight.flightlegs[flt.flight.flightlegs.length - 1].destination
        ) {
          msg += `-------- ${getConnectingTime(
            leg.arrtime,
            leg.arrdate,
            flt.flight.flightlegs[index + 1].deptime,
            flt.flight.flightlegs[index + 1].depdate,
          )} layover in ${leg.destination_name} -------\n`;
        }
      });
      msg += `\nCabin Type : ${PREF_CLASS_OPTIONS[searchRequest.prefclass]}\n`;
      msg += `Stops : ${
        flt.flight.numstops !== 0 ? flt.flight.numstops : 'Non'
      } Stop\n`;
      if (showBreakup) {
        msg += `${flt.fare.faretype} Fare : ${
          appConfig?.appCurrency
        } ${getAmount(selectedReturnFares[returnIndex])}\n`;
      }
    });
    msg += `\n\nThank you for choosing Fastays\nIn case of any urgent support : \n`;
    msg += `Contact : ${contactNum}\n Email : ${fromEmail}\n`;
    onSend(msg, numberWithCountryCode);
    setIsLoading(false);
  };

  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div className="fs-14">
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true"
            name="showBrakup"
            labelText="With Fare"
            value=""
            onChange={() => setShowBreakup(true)}
            checked={showBreakup}
          />
          <AppRadioInput
            id="false"
            name="showBrakup"
            labelText="Without Fare"
            value=""
            onChange={() => setShowBreakup(false)}
            checked={!showBreakup}
          />
        </div>
        <Row
          className="spacing-16 my-2"
          style={{ maxWidth: '716px', margin: '0 auto' }}
        >
          <Col lg={3} md={3} sm={6} xs={4}>
            <AppTextInput
              name="countryCode"
              label="Country Code"
              value={countryCode}
              type="text"
              maxLength={2}
              pattern="[0-9]{1,2}"
              onChange={(d) => setCountryCode(d.target.value)}
            />
          </Col>
          <Col lg={5} md={5} sm={6} xs={8}>
            <AppNumberInput
              name="whatsappNumber"
              label="Enter Mobile Number"
              placeholderText="Enter Customer No"
              value={whatsappNumber}
              onChange={(value) => setWhatsappNumber(value)}
              errorText={validationError && 'Please Enter Mobile Number'}
            />
            {checkValidMobileNumber(whatsappNumber) && validationError && (
              <small className="app-error-text">Enter Valid Number</small>
            )}
          </Col>
          {getValueFromAppConfig('REQUIRE_MARKUP') !== 'true' && (
            <Col lg={4} md={4} sm={6} xs={12}>
              <AppNumberInput
                name="markUpToBeAdded"
                label="Markup"
                value={markUpToBeAdded}
                onChange={(d) => setMarkupToBeAdded(d)}
              />
            </Col>
          )}
        </Row>
        <div className=" d-flex justify-content-center align-items-center">
          <div
            className="overflow-auto"
            style={{
              maxHeight: '350px',
              maxWidth: '750px',
              overflowX: 'auto',
              overflowY: 'auto',
              padding: '1rem',
            }}
          >
            <div className="border" style={{ width: '700px' }}>
              {selectedOnwardFlights.map((selectedFlight, index) => (
                <FlightEmailCard
                  key={selectedFlight.fare.nextraflightkey}
                  flight={selectedFlight.flight}
                  isLast={index === selectedOnwardFlights.length - 1}
                  showHideFare={showBreakup}
                  fare={selectedFlight.fare}
                  index={index}
                  searchRequest={searchRequest}
                  markUpToBeAdded={markUpToBeAdded}
                  isOnward
                  showInput
                  onFareUpdate={() => {}}
                />
              ))}
              {selectedReturnFlights.length > 0 &&
                selectedReturnFlights.map((selectedFlight, index) => (
                  <FlightEmailCard
                    key={selectedFlight.fare.nextraflightkey}
                    flight={selectedFlight.flight}
                    isLast={index === selectedReturnFlights.length - 1}
                    showHideFare={showBreakup}
                    fare={selectedFlight.fare}
                    searchRequest={searchRequest}
                    markUpToBeAdded={markUpToBeAdded}
                    index={index}
                    showInput
                    onFareUpdate={() => {}}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handelSend}
          btnText="Share in Whatsapp"
        />
      </div>
    </div>
  );
}

RoundTripWhatsappModal.propTypes = {
  searchRequest: PropTypes.object.isRequired,
  selectedOnwardFlights: PropTypes.array.isRequired,
  selectedReturnFlights: PropTypes.array.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default RoundTripWhatsappModal;
